import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { Covid19ClosureComponent } from './closure/covid-19-closure.component';

import { Covid19ClosureService } from './closure/covid-19-closure.service';
import { Covid19ReopeningComponent } from "OpsCenter/ops-support/covid-19/reopening/covid-19-reopening.component";
import { Covid19ReopeningService } from "OpsCenter/ops-support/covid-19/reopening/covid-19-reopening.service";
import { SharedModule } from 'OpsCenter/shared/shared.module';

@NgModule({
  imports: [HttpClientModule, CommonModule, SharedModule, FormsModule],
  declarations: [Covid19ClosureComponent, Covid19ReopeningComponent],
  providers: [Covid19ClosureService, Covid19ReopeningService],
  entryComponents: [Covid19ClosureComponent, Covid19ReopeningComponent],
})
export class Covid19Module {
}



// WEBPACK FOOTER //
// ./src/app/ops-support/covid-19/covid-19.module.ts